/**
 * Root reducer.
 * @module reducers/root
 */

import { searchFiltersReducer } from './searchFiltersReducer';
import { searchResultsReducer } from './searchResultsReducer';
import { calendarSearchReducer } from './calendarSearchReducer';
import { calendarDaySearchReducer } from './calendarDaySearchReducer';
import { amministrazioneTrasparenteTree } from './amministrazioneTrasparenteTree';
import { dettagliProcedimento } from './dettagliProcedimento';
import { modulisticaItems } from './modulisticaItems';
import { originalQueryReducer } from './originalQueryReducer';
import { searchBandiFiltersReducer } from './searchBandiFiltersReducer';
import { breadcrumbs } from './breadcrumbs';
import { customNavigation } from './customNavigationReducer';
import { unibaBannerReducer } from './unibaBannerReducer';
import { unibaFooterReducer } from './unibaFooterReducer';
import { unibaLoginButtonReducer } from './unibaLoginButtonReducer';
import { unibaServiziOnlineReducer } from './unibaServiziOnlineReducer';
import { unibaHeaderSlimConfigReducer } from './unibaHeaderSlimConfigReducer';
import { unibaShowServiziOnlineReducer } from './unibaShowServiziOnlineReducer';
import { unibaLanguagesReducer } from './unibaLanguagesReducer';
import { ctSchema } from './ctSchema';
import { contacts } from './contacts';
import { webstatsHeadReducer } from './webstatsHeadReducer';
import { unibaFooterLinksConfigReducer } from './unibaFooterLinksConfigReducer';

/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
const reducers = {
  searchFilters: searchFiltersReducer,
  searchResults: searchResultsReducer,
  calendarSearch: calendarSearchReducer,
  calendarDaySearch: calendarDaySearchReducer,
  amministrazioneTrasparenteTree: amministrazioneTrasparenteTree,
  dettagliProcedimento: dettagliProcedimento,
  modulisticaItems,
  originalQuery: originalQueryReducer,
  searchBandiFilters: searchBandiFiltersReducer,
  breadcrumbs: breadcrumbs,
  customNavigation: customNavigation,
  unibaBanner: unibaBannerReducer,
  unibaFooter: unibaFooterReducer,
  unibaLoginButton: unibaLoginButtonReducer,
  unibaServiziOnline: unibaServiziOnlineReducer,
  unibaHeaderSlimConfig: unibaHeaderSlimConfigReducer,
  unibaFooterLinksConfig: unibaFooterLinksConfigReducer,
  unibaShowServiziOnline: unibaShowServiziOnlineReducer,
  unibaLanguages: unibaLanguagesReducer,
  ct_schema: ctSchema,
  contacts: contacts,
  webstatsHeadReducer: webstatsHeadReducer
};

export default reducers;
